<div class="header">
  <h2>เปลี่ยนรหัสผ่าน</h2>
  <hr>
</div>

<div class="m-t-20 form-center">
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">รหัสผ่านเก่า</label>
    <div class="col-sm-9">
      <input type="password" class="form-control" placeholder="รหัสผ่านเก่า" [(ngModel)]="oldPassword">
    </div>
  </div>
  <hr>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">รหัสผ่านใหม่</label>
    <div class="col-sm-9">
      <input type="password" class="form-control" placeholder="รหัสผ่านใหม่" [(ngModel)]="newPassword">
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">ยืนยันรหัสผ่านใหม่</label>
    <div class="col-sm-9">
      <input type="password" class="form-control" placeholder="ยืนยันรหัสผ่านใหม่" [(ngModel)]="confirmPassword">
      <p class="text-red" *ngIf="errorMessage">{{errorMessage}}</p>
    </div>
  </div>
  <div class="text-right">
    <button class="btn btn-primary" (click)="submit()">บันทึก</button>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.html